/*
 * Lookbook variants — additive, owned by us.
 * Two behaviors, event-delegated + double-init guarded:
 *
 * 1. Size pill change → sync the chosen variant to:
 *      - the hidden <input name="id"> read by <bundle-products> on "Add the look"
 *      - the per-item <add-to-cart data-variant-id> (read live on click)
 *
 * 2. Color swatch click → swap the product IN PLACE (no navigation):
 *      image, title (+ links), and size pills are replaced with the chosen
 *      color's product; hidden id + add-to-cart re-synced. A sold-out color
 *      swaps too and the row shows its sold-out state with a Notify link.
 *      Only modifier / middle clicks fall through to the product page.
 *
 * Size selection rule (shared by initial Liquid render and JS rebuild):
 *      exactly 1 available variant → that pill pre-selected; 2+ → none.
 */
(function () {
  if (window.__lookbookVariantsInit) return;
  window.__lookbookVariantsInit = true;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function firstAvailableId(variants) {
    for (var i = 0; i < variants.length; i++) if (variants[i].available) return variants[i].id;
    return variants.length ? variants[0].id : '';
  }

  // mirror of the Liquid hidden-input default: 1 available -> it; else first available
  function defaultVariantId(variants) {
    var avail = variants.filter(function (v) { return v.available; });
    if (avail.length === 1) return avail[0].id;
    return firstAvailableId(variants);
  }

  // build pills HTML for a color (empty string when there is no real size choice)
  function renderPills(blockId, variants) {
    if (!variants || !variants.length) return '';
    // a lone "Default Title" variant is not a size choice; a lone real size (e.g. One size) still gets its pill
    if (variants.length === 1 && /^default title$/i.test(String(variants[0].title || ''))) return '';
    var availCount = variants.filter(function (v) { return v.available; }).length;
    var html = '';
    variants.forEach(function (v, i) {
      var id = 'lb-size-' + blockId + '-' + (i + 1);
      html += '<input type="radio" class="lookbook-size__input" id="' + id + '" name="lb-size-' + blockId + '" value="' + v.id + '" data-variant-id="' + v.id + '"'
        + (v.price ? ' data-price="' + v.price + '"' : '')
        + (availCount === 1 && v.available ? ' checked' : '')
        + (v.available ? '' : ' disabled') + '>';
      html += '<label class="lookbook-size__pill" for="' + id + '">' + escapeHtml(v.title) + '</label>';
    });
    return html;
  }

  function syncHidden(item, variantId) {
    if (!variantId) return;
    var hidden = item.querySelector('input[name="id"]');
    if (hidden) hidden.value = variantId;
    var atc = item.querySelector('add-to-cart');
    if (atc) atc.setAttribute('data-variant-id', variantId);
  }

  // 1. size pill chosen
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('lookbook-size__input')) return;
    if (input.disabled) return;
    var item = input.closest('bundle-product');
    if (item) syncHidden(item, input.getAttribute('data-variant-id'));
  });

  // 2. color swatch chosen → swap in place
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-lb-swatch]');
    if (!sw) return;
    // let modifier / middle clicks navigate to the PDP
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    var item = sw.closest('bundle-product');
    if (!item) return;
    e.preventDefault();

    var variants;
    try { variants = JSON.parse(sw.getAttribute('data-variants') || '[]'); } catch (_) { variants = []; }

    var url = sw.getAttribute('data-url');

    // image
    var img = item.querySelector('.product-image img');
    if (img) {
      var i1 = sw.getAttribute('data-img'), i2 = sw.getAttribute('data-img2x');
      if (i1) { img.setAttribute('src', i1); img.setAttribute('srcset', i1 + ' 1x' + (i2 ? ', ' + i2 + ' 2x' : '')); }
    }
    // title text + link, and image link
    var titleEl = item.querySelector('a.product-title');
    if (titleEl) {
      var t = sw.getAttribute('data-title');
      if (t) titleEl.textContent = t;
      if (url) titleEl.setAttribute('href', url);
    }
    var imgLink = item.querySelector('.product-image a');
    if (imgLink && url) imgLink.setAttribute('href', url);
    var notify = item.querySelector('[data-lookbook-notify]');
    if (notify && url) notify.setAttribute('href', url);

    // size pills
    var sizes = item.querySelector('[data-lb-sizes]');
    if (sizes) sizes.innerHTML = renderPills(sizes.getAttribute('data-block-id') || '', variants);

    // hidden id + add-to-cart
    syncHidden(item, defaultVariantId(variants));
    // keep the resolved-variant marker in step with the new color (one available size resolves by itself)
    var availNow = variants.filter(function (v) { return v.available; });
    if (availNow.length === 1) item.setAttribute('data-default-variant', availNow[0].id);
    else item.removeAttribute('data-default-variant');

    // move the "current" highlight
    var all = item.querySelectorAll('[data-lb-swatch]');
    for (var k = 0; k < all.length; k++) { all[k].classList.remove('lookbook-swatch--current'); all[k].removeAttribute('aria-current'); }
    sw.classList.add('lookbook-swatch--current');
    sw.setAttribute('aria-current', 'true');
  });
})();
